import { SearchDriverOptions } from '@elastic/search-ui';
import ElasticSearchAPIConnector from '@elastic/search-ui-elasticsearch-connector';
import { elasticPrimaryConfig } from '@scripts/frontend/elastic/elastic-client';

const elasticConnector = (jobId: string) => new ElasticSearchAPIConnector({
  ...elasticPrimaryConfig,
  interceptSearchRequest: async (
    { requestBody },
    next,
  ) => {
    requestBody.query = {
      bool: {
        must: [{
          more_like_this: {
            fields: ['job_title', 'job_description'],
            like: [{
              _index: 'jobs-north-america',
              _id: jobId,
            }],
            min_term_freq: 1,
            max_doc_freq: 20,
            max_query_terms: 5,
          },
        }],
        must_not: [{ // Exclude the current job from results
          term: {
            _id: jobId,
          },
        }],
      },
    };
    return next(requestBody);
  },
});

export const relatedJobsConfig = (numberToShow: string, jobId: string): SearchDriverOptions => ({
  alwaysSearchOnInitialLoad: true,
  trackUrlState: false,
  initialState: {
    resultsPerPage: parseInt(numberToShow, 10),
    searchTerm: 't',
  },
  searchQuery: {
    result_fields: {
      job_title: {
        raw: {},
      },
      job_description: {
        snippet: {},
      },
      location: {
        raw: {},
      },
      salary: {
        raw: {},
      },
      job_id: {
        raw: {},
      },
      posted_date: {
        raw: {},
      },
    },
  },
  apiConnector: elasticConnector(jobId),
});
